<template>
  <b-card class="w-100">
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Firma Adı">
        <b-form-input v-model="form.company_name" />
      </b-form-group>

      <b-form-group label="Domain">
        <b-form-input v-model="form.domain" />
      </b-form-group>

      <b-form-group label="Short Link Domain (Ops)">
        <b-form-input v-model="form.short_link_domain" />
      </b-form-group>

      <b-form-group label="Cari Bilgisi">
        <b-form-input v-model="form.cari_name" />
      </b-form-group>

      <b-form-group label="Admin E-posta">
        <b-form-input type="email" v-model="form.admin_email" />
      </b-form-group>

      <b-form-group label="Telefon">
        <b-form-input v-model="form.phone" />
      </b-form-group>

      <b-form-group label="Altyapı Bilgisi">
        <b-form-select v-model="form.altyapi" :options="altyapiOptions" />
      </b-form-group>

      <b-form-group label="Muhasebe E-posta">
        <b-form-input type="email" v-model="form.accounting_email" />
      </b-form-group>

      <b-form-group label="Başlangıç Paketi">
        <b-form-select v-model="form.package" :options="packages" />
      </b-form-group>

      <b-form-group label="Not">
        <b-form-textarea v-model="form.note" rows="3" />
      </b-form-group>

      <b-button type="submit" variant="primary" :disabled="loading">
        {{ form.id ? 'Güncelle' : 'Kaydet' }}
      </b-button>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BButton,
  BAlert,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "DemoRequestForm",
  components: {
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BButton,
    BAlert,
  },
  props: {
    // Düzenleme yapılacaksa kaydın bilgileri buraya gönderilir
    editData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        company_name: "",
        domain: "",
        short_link_domain: "",
        cari_name: "",
        admin_email: "",
        phone: "",
        altyapi: "T-Soft",
        accounting_email: "",
        package: "Small Paket",
        note: "",
      },
      altyapiOptions: [
        { value: "T-Soft", text: "T-Soft" },
        { value: "Ticimax", text: "Ticimax", disabled: true },
        { value: "0", text: "Diğer" },
      ],
      packages: [
        { value: "Small Paket", text: "Small Paket" },
        { value: "Medium Paket", text: "Medium Paket" },
        { value: "Large Paket", text: "Large Paket" },
      ],
      loading: false,
      error: "",
    };
  },
  mounted() {
    if (this.editData) {
      this.form = { ...this.form, ...this.editData };
    }
  },
  methods: {
    async submitForm() {
      this.loading = true;
      this.error = "";

      const isEdit = !!this.form.id;
      const method = isEdit ? "put" : "post";

      try {
        const res = await this.$http[method]('/manage/customer/demo', this.form);
        if (res.data.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Başarılı!",
              text: res.data.message,
              variant: "success",
            },
          });
          this.$emit("refetch-data");
          this.$emit("modal-false"); // modal’ı kapat
          if (!isEdit) {
            this.resetForm();
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Uyarı!",
              text: res.data.error || "Bir hata oluştu",
              variant: "danger",
            },
          });
        }
      } catch (e) {
        this.error = "Sunucu hatası: " + e;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        id: null,
        company_name: "",
        domain: "",
        short_link_domain: "",
        cari_name: "",
        admin_email: "",
        phone: "",
        altyapi: "T-Soft",
        accounting_email: "",
        package: "Small Paket",
        note: "",
      };
    },
  },
};
</script>
